
/*----------------------
       SLIDER LOGOS (prensa)
  Desktop: auto slides loop
  Mobile: carousel soft (no grid wrap = no “duplicados”)
---------------------- */
SliderLogos = {
    swiper: null,
    init: function () {
        var el = document.querySelector(".swiper-logos");
        if (!el) return;

        if (this.swiper && typeof this.swiper.destroy === "function") {
            try {
                this.swiper.destroy(true, true);
            } catch (e) {}
            this.swiper = null;
        }

        var isMobile = window.matchMedia("(max-width: 640px)").matches;

        this.swiper = new Swiper(".swiper-logos", {
            slidesPerView: isMobile ? 2.35 : "auto",
            spaceBetween: isMobile ? 28 : 0,
            centeredSlides: false,
            loop: true,
            speed: isMobile ? 900 : 600,
            allowTouchMove: true,
            autoplay: {
                delay: isMobile ? 2200 : 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            },
            freeMode: isMobile
                ? { enabled: true, momentum: true, sticky: false }
                : false,
            watchOverflow: true
        });
    }
};

$(document).ready(function () {
    SliderLogos.init();
});
$(document).on("shopify:section:load", function () {
    SliderLogos.init();
});

var logosResizeTimer;
$(window).on("resize", function () {
    clearTimeout(logosResizeTimer);
    logosResizeTimer = setTimeout(function () {
        SliderLogos.init();
    }, 200);
});
